import ExamAttemptExpiredModal from '../../../components/Modals/StatusUpdateModals/ExamAttemptExpiredModal';
// @ts-expect-error Untypes import
import TrackNavigatorContainer from '../../../containers/Navigator/TrackNavigator/TrackNavigatorContainer';
import styled from 'styled-components';
import { device } from '../../../constants/StyledComponentConstants';
import { useExpiredModalState } from '../examsStores';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileOnly = styled.div.withConfig({
  displayName: "ExamLayout__MobileOnly",
  componentId: "sc-1butpu7-0"
})(["@media screen and ", "{display:none;}"], device.not.tablet);
const ExamContainerDiv = styled.div.withConfig({
  displayName: "ExamLayout__ExamContainerDiv",
  componentId: "sc-1butpu7-1"
})(["padding-bottom:70px;"]);
const ExamLayout = ({
  children
}) => {
  const {
    showExpiredModal,
    setShowExpiredModal
  } = useExpiredModalState();
  return /*#__PURE__*/_jsx(ExamContainerDiv, {
    className: "exam-container",
    "data-test-id": "exam-container",
    children: /*#__PURE__*/_jsxs("div", {
      className: "exam-container__exam",
      children: [showExpiredModal && /*#__PURE__*/_jsx(ExamAttemptExpiredModal, {
        onView: () => setShowExpiredModal(false)
      }), children, /*#__PURE__*/_jsx(MobileOnly, {
        children: /*#__PURE__*/_jsx(TrackNavigatorContainer, {})
      })]
    })
  });
};
export default ExamLayout;